<div class="modal-container">
  <!-- Header -->
  <div class="modal-header">
    <h2 class="modal-title">Información Contratante</h2>
    <button type="button" class="btn-close" (click)="cerrar()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="modal-body">
    <!-- Indicador de carga al elegir "Sí" -->
    <div *ngIf="cargando" class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p class="loading-text">Cargando...</p>
    </div>
    <!-- Pregunta Principal (siempre se muestra) -->
    <div *ngIf="esUsuario === null && !cargando" class="pregunta-container">
      <p class="pregunta">¿El contratante es usuario?</p>
      
      <div class="botones-respuesta">
        <button 
          type="button" 
          class="btn-respuesta btn-si"
          (click)="seleccionarSi()">
          SI
        </button>
        
        <button 
          type="button" 
          class="btn-respuesta btn-no"
          (click)="seleccionarNo()">
          NO
        </button>
      </div>
    </div>
  </div>
</div>
